import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ConfigDB from "../../config";
import {
  deletePartQty,
  getpartInventoryQuentityDetails,
  getwarHouseEntityList,
  partInvenToryLocationUpdate,
  recoverPartQty,
} from "../../services/PartsInventory";
import { toast } from "react-toastify";
import {
  Button,
  Form,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Barcode from "react-barcode";
import Utils from "../../utils";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const PartInventoryDetails = () => {
  const { uuid } = useParams();
  const tableLengthList = ConfigDB.data.dataTableLength;
  const { t } = useTranslation();
  const { state } = useLocation();

  const navigate = useNavigate();

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
  });
  const [entityList, setEntityList] = useState([]);

  const [partDetails, setPartDetails] = useState([]);

  const [qrDetails, setQrDetails] = useState(false);

  const [DelPartQRId, setDelPartQRId] = useState("");

  const [selectedEntities, setSelectedEntities] = useState({});

  const [selectedEntityNames, setSelectedEntityNames] = useState({});

  const [partLocationDetails, setPartLocationDetails] = useState("");
  const [delModal, setDelModal] = useState(false);
  const [recoverModel, setRecoverModel] = useState(false);
  const [delPartId, setDelPartId] = useState("");
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [isRecoverButtonLoad, setIsRecoverButtonLoad] = useState(false);

  const [showeDeletedQty, setShoweDeletedQty] = useState({
    show_deleted_qty: 1,
  });

  const handleDescriptionChange = (e, itemId) => {
    const { value } = e.target;

    setSelectedEntities((prev) => ({
      ...prev,
      [itemId]: {
        ...(prev[itemId] || {}),
        description: value, // update description
        location_ids: prev[itemId]?.location_ids || "",
      },
    }));
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelPartId(item);
    setDelModal(true);
  };

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const onRecoverModalOpen = (e, item) => {
    e.preventDefault();
    setDelPartId(item);
    setRecoverModel(true);
  };

  const onRecoverModalClose = () => {
    setRecoverModel(false);
  };

  const onDestroyPartInventory = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { id: delPartId.id, part_id: delPartId.parts_id };

    deletePartQty(data)
      .then((response) => {
        toast.success(response.data.message);
        let data = {
          part_id: uuid,
          show_deleted_qty: showeDeletedQty?.show_deleted_qty,
        };
        getpartInventoryQuentityDetails(data)
          .then((response) => {
            setPartDetails(response.data.data);
          })
          .catch((err) => {
            toast.error(err.message);
          });
        setDelPartId("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const onRecoverPartInventory = (e) => {
    e.preventDefault();
    setIsRecoverButtonLoad(true);
    let data = { qty_id: delPartId.id, part_id: delPartId.parts_id };

    recoverPartQty(data)
      .then((response) => {
        toast.success(response.data.message);
        let data = {
          part_id: uuid,
          show_deleted_qty: showeDeletedQty?.show_deleted_qty,
        };
        getpartInventoryQuentityDetails(data)
          .then((response) => {
            setPartDetails(response.data.data);
          })
          .catch((err) => {
            toast.error(err.message);
          });
        setDelPartId("");
        setRecoverModel(false);
        setIsRecoverButtonLoad(false);
      })
      .catch((err) => {
        setIsRecoverButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const randomStrings = `${DelPartQRId.parts_id}-${DelPartQRId.parts_internal_id}`;
  const findNodeById = (nodes, id) => {
    for (const node of nodes) {
      if (node.id == id) {
        return node;
      }
      if (node.children) {
        const found = findNodeById(node.children, id);
        if (found) return found;
      }
    }
    return null;
  };

  useEffect(() => {
    const initialEntities = {};
    partDetails.forEach((item) => {
      initialEntities[item.id] = {
        location_ids: item.location_ids || "", // default if any
        description: item.description || "", // default empty
      };
    });
    setSelectedEntities(initialEntities);
  }, [partDetails]);

  const handleSelectChange = (event, item) => {
    if (!item?.id) return;

    const value = event.target.value;

    // When "Select" is chosen
    if (value === "0") {
      setSelectedEntities((prev) => ({
        ...prev,
        [item.id]: {
          ...(prev[item.id] || {}),
          location_ids: null,
          description: prev[item.id]?.description || "",
        },
      }));
      return;
    }

    const selectedNode = findNodeById(entityList, value);

    // 🚨 IMPORTANT GUARD
    if (!selectedNode?.id) return;

    setSelectedEntities((prev) => ({
      ...prev,
      [item.id]: {
        ...(prev[item.id] || {}),
        location_ids: selectedNode.id,
        description: prev[item.id]?.description || "",
      },
    }));
  };

  const onQrDetailsOpen = (e, item) => {
    e.preventDefault();
    setDelPartQRId(item);
    setQrDetails(true);
  };

  const handleQrDetailsClose = () => {
    setQrDetails(false);
  };

  useEffect(() => {
    let data = { ...params };
    getwarHouseEntityList(data)
      .then((response) => {
        setEntityList(response.data.data);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [params]);

  useEffect(() => {
    let data = {
      part_id: uuid,
      show_deleted_qty: showeDeletedQty?.show_deleted_qty,
    };
    getpartInventoryQuentityDetails(data)
      .then((response) => {
        setPartDetails(response.data.data);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [uuid, showeDeletedQty]);

  const renderOptions = (nodes, level = 0) => {
    return nodes?.map((node) => {
      if (node.children && node.children.length > 0) {
        return (
          <>
            <optgroup
              label={"\u00A0\u00A0".repeat(level) + node.warehouse_name}
              key={node.id}
            />
            {renderOptions(node.children, level + 1)}
          </>
        );
      } else {
        return (
          <option value={node.id} key={node.id}>
            {"\u00A0\u00A0".repeat(level) + node.warehouse_name}
          </option>
        );
      }
    });
  };
  // const renderOptions = (nodes, level = 0) => {
  //   return nodes?.map((node) => (
  //     <React.Fragment key={node.id}>
  //       {" "}
  //       <option
  //         value={node.id}
  //         style={{ fontWeight: node.children?.length ? "bold" : "normal" }}
  //       >
  //         {" "}
  //         {"\u00A0\u00A0".repeat(level) + node.warehouse_name}{" "}
  //       </option>{" "}
  //       {node.children?.length > 0 && renderOptions(node.children, level + 1)}{" "}
  //     </React.Fragment>
  //   ));
  // };

  // const renderGroupedOptions = (nodes) => {
  //     if (!nodes || nodes.length === 0) return null;
  //
  //     // Group nodes by warehouse_type_name
  //     const grouped = nodes.reduce((acc, node) => {
  //         const typeName = node.warehouse_type_name || 'Others';
  //         if (!acc[typeName]) acc[typeName] = [];
  //         acc[typeName].push(node);
  //         return acc;
  //     }, {});
  //
  //
  //     // Render each group
  //     return Object.entries(grouped).map(([typeName, groupNodes]) => (
  //         <optgroup label={typeName} key={typeName}>
  //             {groupNodes.map((node) => renderOptions(node.children ? [node] : node))}
  //         </optgroup>
  //     ));
  // };

  const handleSubmitLocation = (e) => {
    e.preventDefault();

    // const hasInvalidDescription = Object.values(selectedEntities).some(
    //   (item) => item.location_ids && !item.description?.trim()
    // );

    // if (hasInvalidDescription) {
    //   toast.error("Description is required for all selected entities");
    //   return;
    // }

    const payloadArray = Object.entries(selectedEntities)
      // .filter(([id, data]) => data.location_ids)
      .map(([id, data]) => ({
        id: id,
        qty: partLocationDetails.qty,
        location_ids: data.location_ids || 0,
        description: data.description || "",
      }));

    const payload = {
      part_id: uuid,
      location_list: payloadArray,
    };

    partInvenToryLocationUpdate(payload)
      .then((response) => {
        toast.success(response.data.message);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6"></div>
              <div className="col-sm-6"></div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="">
                    <div className="card-header">
                      <div className="col-md-6">
                        <Select
                          options={ConfigDB?.data?.partQuantityList}
                          value={
                            ConfigDB?.data?.partQuantityList.find(
                              (option) =>
                                option.value ===
                                showeDeletedQty.show_deleted_qty,
                            ) || null
                          }
                          onChange={(selectedOption) =>
                            setShoweDeletedQty({
                              ...showeDeletedQty,
                              show_deleted_qty: selectedOption
                                ? selectedOption.value
                                : "",
                            })
                          }
                          placeholder={"Select"}
                          isSearchable
                        />
                      </div>
                    </div>
                    <Form method={`post`} onSubmit={handleSubmitLocation}>
                      <div className="card-body fuelCardB">
                        <div className="vehicleThBg table-responsive">
                          <table className="table table-bordered rounded-table table-striped table-hover">
                            <thead>
                              <tr>
                                <th>Part Name</th>
                                <th>Quantity</th>
                                <th style={{ width: "20%" }}>Entity</th>
                                <th style={{ width: "10%" }}></th>

                                <th style={{ width: "10%" }}>Bar Code</th>

                                <th style={{ width: "20%" }}>Description</th>
                                {/* {state?.record_show_type === 0 && (
                                  <th style={{ width: "10%" }}>Action</th>
                                )} */}
                                {/* {partDetails?.some(
                                  (item) => item?.deleted_at === null, */}
                                <th style={{ width: "20%" }}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {partDetails && partDetails?.length > 0 ? (
                                partDetails.map((item, index) => {
                                  return (
                                    <>
                                      <tr key={index}>
                                        <td>{item.part_name}</td>
                                        <td>{item.qty}</td>

                                        <td>
                                          <select
                                            className="form-select"
                                            value={
                                              selectedEntities?.[item?.id]
                                                ?.location_ids ??
                                              item?.location_ids ??
                                              "0"
                                            }
                                            onChange={(e) =>
                                              handleSelectChange(e, item)
                                            }
                                            disabled={
                                              item?.is_sold === 1 ||
                                              item.deleted_at
                                            }
                                          >
                                            <option value="0">Select</option>
                                            {renderOptions(entityList)}
                                          </select>
                                        </td>

                                        {(selectedEntities[item.id]
                                          ?.location_ids ||
                                          item.location_ids) &&
                                        item.is_sold !== 1 &&
                                        item.deleted_at === null ? (
                                          <td>
                                            <a
                                              href="#"
                                              onClick={() => {
                                                setSelectedEntities((prev) => ({
                                                  ...prev,
                                                  [item.id]: {
                                                    location_ids: "0",
                                                  },
                                                }));
                                              }}
                                            >
                                              <i
                                                className="bi bi-x-lg"
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                }}
                                              ></i>
                                            </a>
                                          </td>
                                        ) : (
                                          <td>-</td>
                                        )}

                                        {(selectedEntities[item.id]
                                          ?.location_ids ||
                                          item.location_ids) &&
                                        item.is_sold !== 1 &&
                                        item.deleted_at === null ? (
                                          <td>
                                            <a
                                              href="#"
                                              onClick={(e) =>
                                                onQrDetailsOpen(e, item)
                                              }
                                            >
                                              <i
                                                className="bi bi-qr-code-scan"
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                }}
                                              ></i>
                                            </a>
                                          </td>
                                        ) : (
                                          <td>-</td>
                                        )}
                                        {/* {(selectedEntities[item.id]
                                          ?.location_ids ||
                                          item.location_ids) &&
                                        item.is_sold !== 1 ? ( */}
                                        <td>
                                          <textarea
                                            className="form-control"
                                            placeholder={t("pi_enter_description")}
                                            value={
                                              selectedEntities[item.id]
                                                ?.description ||
                                              item.description ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              handleDescriptionChange(
                                                e,
                                                item.id,
                                              )
                                            }
                                            disabled={
                                              item.is_sold === 1 ||
                                              item.deleted_at
                                            }
                                            rows={3}
                                          />
                                        </td>
                                        {/* ) : (
                                            <td>-</td>
                                          )} */}
                                        <td>
                                          {item.deleted_at === null ? (
                                            item.is_sold === 1 ? (
                                              <div className="edit-btn">
                                                <i className="bi bi-cart-x-fill"></i>
                                              </div>
                                            ) : (
                                              <div className="trash-btn">
                                                <a
                                                  className="delete-btn"
                                                  href="#"
                                                  onClick={(e) =>
                                                    onDeleteModalOpen(e, item)
                                                  }
                                                >
                                                  <i className="bi bi-trash3"></i>
                                                </a>
                                              </div>
                                            )
                                          ) : (
                                            <div className="edit-btn">
                                              <a
                                                className="edit-btn"
                                                href="#"
                                                onClick={(e) =>
                                                  onRecoverModalOpen(e, item)
                                                }
                                              >
                                                <i className="bi bi-arrow-counterclockwise"></i>{" "}
                                                {/* optional: different icon for recover */}
                                              </a>
                                            </div>
                                          )}
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td
                                    colSpan="5"
                                    style={{ textAlign: "center" }}
                                  >
                                    No Quantity Data Found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="col mt-2">
                          <div className="d-flex justify-content-end nxt-btn">
                            <div className="col">
                              <Button
                                type="button"
                                className="back-btn ms-0 "
                                onClick={() => navigate("/parts-inventory")}
                              >
                                <i className="bi bi-arrow-left"></i> {t("back")}
                              </Button>
                            </div>
                            {partDetails.length > 0 &&
                              showeDeletedQty?.show_deleted_qty !== 2 && (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  Submit <i className="bi bi-check2"></i>
                                </button>
                              )}
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal isOpen={qrDetails}>
        <ModalHeader>{`QR Details`}</ModalHeader>
        <ModalBody>
          <div className="">
            <div className="" style={{ display: "none" }}>
              <Label className="d-flex justify-content-center">Part Code</Label>
              <div className="svg-barshelf">
                <Barcode value={randomStrings} width={3} height={100} />
              </div>
            </div>

            <div className="">
              <Label className="d-flex justify-content-center">Location</Label>
              <div className="svg-barshelf">
                <Barcode
                  value={
                    selectedEntityNames[partLocationDetails?.id] &&
                    selectedEntities[partLocationDetails?.id]
                      ? `${selectedEntityNames[partLocationDetails.id]}`
                      : `${DelPartQRId?.warehouse_name || ""}`
                  }
                  format="CODE128"
                  width={3}
                  height={100}
                  displayValue={true}
                  margin={10}
                />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleQrDetailsClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={delModal}>
        <ModalHeader>{`Delete quntity`}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>{`Are you sure you want to delete quntity?`}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-x-lg"></i>
          </button>

          {/* {state?.record_show_type === 0 && ( */}
          <button
            type="button"
            className="btn btn-block bg-red"
            style={{ width: "100px" }}
            onClick={onDestroyPartInventory}
            disabled={isDelButtonLoad} // disable while loading
          >
            {isDelButtonLoad ? (
              <>
                <i className="fa fa-circle-o-notch fa-spin"></i> Loading...
              </>
            ) : (
              <>
                Delete <i className="bi bi-trash3"></i>
              </>
            )}
          </button>
          {/* )} */}
        </ModalFooter>
      </Modal>

      <Modal isOpen={recoverModel}>
        <ModalHeader>{`Restore quntity`}</ModalHeader>
        <ModalBody>
          <p
            className={`mb-0`}
          >{`Are you sure you want to restore quntity?`}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isRecoverButtonLoad}
            onClick={onRecoverModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "100px" }}
            onClick={onRecoverPartInventory}
            disabled={isRecoverButtonLoad} // disable while loading
          >
            {isRecoverButtonLoad ? (
              <>
                <i className="fa fa-circle-o-notch fa-spin"></i> Loading...
              </>
            ) : (
              <>
                Restore <i className="bi bi-arrow-counterclockwise"></i>
              </>
            )}
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default PartInventoryDetails;
